import { jsx, jsxs } from "react/jsx-runtime";
function NoData() {
    return /*#__PURE__*/ jsxs("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 120 120",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ jsxs("g", {
                clipPath: "url(#clip0_1362_692)",
                children: [
                    /*#__PURE__*/ jsx("path", {
                        d: "M12 66.75H36V105.75C36 107.407 34.6569 108.75 33 108.75H15C13.3431 108.75 12 107.407 12 105.75V66.75Z",
                        fill: "#D8DEEA"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M39 66.75H108V105.75C108 107.407 106.657 108.75 105 108.75H42C40.3431 108.75 39 107.407 39 105.75V66.75Z",
                        fill: "#EBEFF5"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M47.1975 48.8071C47.7243 47.8469 48.7325 47.25 49.8277 47.25H112.682C114.963 47.25 116.409 49.6936 115.313 51.6929L108.698 63.75H39L47.1975 48.8071Z",
                        fill: "#EBEFF5"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M4.63022 51.6719C3.55438 49.6732 5.002 47.25 7.27184 47.25H25.3262C26.43 47.25 27.4447 47.8561 27.9679 48.8281L36 63.75H11.1316L4.63022 51.6719Z",
                        fill: "#D8DEEA"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M12 105.75H36V108.75H15C13.3431 108.75 12 107.407 12 105.75Z",
                        fill: "#AFB9C9"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M39 105.75H108C108 107.407 106.657 108.75 105 108.75H39V105.75Z",
                        fill: "#D8DEEA"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M81.75 12H42C40.3431 12 39 13.3431 39 15V39H81.75C83.4069 39 84.75 37.6569 84.75 36V15C84.75 13.3431 83.4069 12 81.75 12Z",
                        fill: "#EBEFF5"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M39 38.2646V43.1746C39 44.4106 40.4111 45.1162 41.4 44.3746L49.5661 38.25L39 38.2646Z",
                        fill: "#EBEFF5"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M51.3915 28.533C52.8504 28.533 54.033 27.3504 54.033 25.8915C54.033 24.4326 52.8504 23.25 51.3915 23.25C49.9327 23.25 48.75 24.4326 48.75 25.8915C48.75 27.3504 49.9327 28.533 51.3915 28.533Z",
                        fill: "#AFB9C9"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M61.9245 28.533C63.3833 28.533 64.566 27.3504 64.566 25.8915C64.566 24.4326 63.3833 23.25 61.9245 23.25C60.4656 23.25 59.283 24.4326 59.283 25.8915C59.283 27.3504 60.4656 28.533 61.9245 28.533Z",
                        fill: "#AFB9C9"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M72.4577 28.533C73.9166 28.533 75.0992 27.3504 75.0992 25.8915C75.0992 24.4326 73.9166 23.25 72.4577 23.25C70.9988 23.25 69.8162 24.4326 69.8162 25.8915C69.8162 27.3504 70.9988 28.533 72.4577 28.533Z",
                        fill: "#AFB9C9"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M51.75 79.5H80.1516",
                        stroke: "#AFB9C9",
                        strokeWidth: "3",
                        strokeLinecap: "round"
                    }),
                    /*#__PURE__*/ jsx("path", {
                        d: "M51.75 88.5H68.791",
                        stroke: "#AFB9C9",
                        strokeWidth: "3",
                        strokeLinecap: "round"
                    })
                ]
            }),
            /*#__PURE__*/ jsx("defs", {
                children: /*#__PURE__*/ jsx("clipPath", {
                    id: "clip0_1362_692",
                    children: /*#__PURE__*/ jsx("rect", {
                        width: "120",
                        height: "120",
                        fill: "white"
                    })
                })
            })
        ]
    });
}
export { NoData as default };
